//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TableEmptyData from '@/components/Shared/Table/TableEmptyData'
import SupervisorAssignmentSelect from '@/components/Projects/NewProjectSteps/StepSupervisorCollaborator/SupervisorAssignmentSelect.vue'
import ModalDeleteUser from '@/components/Projects/users/ModalDeleteUser.vue'
import handleErrorMixin from '@/mixins/handleErrorMixin'
import PROJECT_ROLES from '@/constants/project-roles'
import ModalConfirmChangeSupervisor from '../ModalConfirmChangeSupervisor.vue'
import ModalAlertChangeSupervisor from '../ModalAlertChangeSupervisor.vue'
import InvitationStatusTag from './InvitationStatusTag.vue'
import CollaboratorInfo from './CollaboratorInfo.vue'
import CollaboratorActions from './CollaboratorActions.vue'
import ConfirmRegisterUserWithEmailModal from '~/components/Invitation/ConfirmRegisterUserWithEmailModal.vue'
import ASSIGNMENT_STATUS from '~/constants/assigment-validation-status'
import { showSuccessNotification } from '~/util/notifications'
export default {
  components: {
    TableEmptyData,
    InvitationStatusTag,
    CollaboratorInfo,
    CollaboratorActions,
    SupervisorAssignmentSelect,
    ModalDeleteUser,
    ConfirmRegisterUserWithEmailModal,
    ModalConfirmChangeSupervisor,
    ModalAlertChangeSupervisor,
  },
  filters: {
    fullNames(user) {
      return `${user?.names} ${user?.lastnames}`
    },
    showEmail(user) {
      return user?.email
    },
  },
  mixins: [handleErrorMixin],
  props: {
    project: {
      type: Object,
      default: () => ({}),
    },
    users: {
      type: Array,
      default: () => [],
    },
    selectedRows: {
      type: Array,
      default: () => [],
    },
    supervisors: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      selectedItems: [],
      rowToDelete: {},
      rowToUpdate: {},
      isShowModalDeleteUsers: false,
      isShowConfirmResendInvitation: false,
      isShowModalChangeSupervisor: false,
      isShowAlertChangeSupervisor: false,
    }
  },
  computed: {
    supervisorsFormatted() {
      return this.supervisors.map((supervisor) => ({
        value: supervisor.id,
        label: `${supervisor.names} ${supervisor.lastnames}`,
      }))
    },
    userToDelete() {
      return this.rowToDelete?.collaborator || {}
    },
  },
  watch: {
    selectedRows(selectedRows) {
      this.selectedItems = selectedRows
    },
  },
  methods: {
    isPendingInvitation(row) {
      return row.collaborator.show_change_password_modal
    },
    handleChecked(rows) {
      this.$emit('checked', rows)
    },
    isCheckable(row) {
      return (
        this.isPendingInvitation(row) && !row.collaborator.autogenerated_email
      )
    },
    supevisorRowFormat(supervisor) {
      if (!supervisor) {
        return null
      }
      return {
        value: supervisor?.id,
        label: `${supervisor?.names} ${supervisor?.lastnames}`,
      }
    },
    generateComposeId(supervisorAssignment) {
      if (supervisorAssignment.supervisor === null) {
        return `${supervisorAssignment.id}-${supervisorAssignment.collaborator.id}`
      }
      return `${supervisorAssignment.id}-${supervisorAssignment.collaborator.id}-${supervisorAssignment.supervisor.id}`
    },
    async goToProfile(row) {
      await this.$router.push(`/mis-trabajadores/${row.collaborator.id}`)
    },
    toogleModalDeleteUsers() {
      this.isShowModalDeleteUsers = !this.isShowModalDeleteUsers
    },
    toogleModalResendInvitation() {
      this.isShowConfirmResendInvitation = !this.isShowConfirmResendInvitation
    },
    toogleModalChangeSupervisor() {
      this.isShowModalChangeSupervisor = !this.isShowModalChangeSupervisor
    },
    toogleModalAlertChangeSupervisor() {
      this.isShowAlertChangeSupervisor = !this.isShowAlertChangeSupervisor
    },
    handeClickDeleteUser(row) {
      this.rowToDelete = row
      this.toogleModalDeleteUsers()
    },
    async deleteUserConfirmed() {
      try {
        this.$store.commit('loading', true)
        await this.$repository.user.removeOfProject(
          this.project.id,
          this.rowToDelete.collaborator.id,
          PROJECT_ROLES.COLLABORATOR
        )
        if (this.rowToDelete.supervisor_project_role_id) {
          await this.$repository.projectRoles.updateValidationStatus(
            this.project.id,
            this.rowToDelete.supervisor.id,
            true
          )
        }

        this.$emit('delete-user', this.rowToDelete.collaborator.id)
        this.rowToDelete = {}
      } catch (error) {
        this.handleError(error, 'Ocurrió un error al eliminar el usuario')
      } finally {
        this.$store.commit('loading', false)
      }
    },
    async resendInvitation(row) {
      try {
        this.$store.commit('loading', true)
        await this.$repository.invitation.collaboratorEmployeeReminderInvitation(
          {
            usersIds: [row.collaborator.id],
            projectId: this.project.id,
          }
        )
        this.toogleModalResendInvitation()
      } catch (error) {
        this.handleError(error, 'Ocurrió un error al reenviar la invitación')
      } finally {
        this.$store.commit('loading', false)
      }
    },
    async handleSelectSupervisor(supervisorAssignment, rowAssignment) {
      try {
        this.$store.commit('loading', true)
        if (!rowAssignment.supervisor) {
          this.$emit('handle-select-supervisor', {
            supervisorAssignment,
            rowAssignment,
          })
          return
        }
        if (rowAssignment.supervisor.id === supervisorAssignment.supervisorId) {
          return
        }
        this.rowToUpdate = {
          ...supervisorAssignment,
          newSupervisor: this.supervisors.find(
            (supervisor) => supervisor.id === supervisorAssignment.supervisorId
          ),
          oldSupervisor: { ...rowAssignment.supervisor },
        }

        const [
          status,
        ] = await this.$repository.supervisorAssignments.getValidationStatus(
          this.project.id,
          rowAssignment.supervisor.id,
          rowAssignment.collaborator.id
        )

        status?.validation_status === ASSIGNMENT_STATUS.PENDING
          ? this.toogleModalChangeSupervisor()
          : this.toogleModalAlertChangeSupervisor()
      } catch (error) {
        this.handleError(error, 'Ocurrió un error al seleccionar el supervisor')
      } finally {
        this.$store.commit('loading', false)
      }
    },
    async handleConfirmChangeSupervisor() {
      try {
        this.$store.commit('loading', true)
        await this.$repository.supervisorAssignments.changeSupervisorAssignment(
          this.project.id,
          this.rowToUpdate.oldSupervisor.id,
          this.rowToUpdate.newSupervisor.id,
          this.rowToUpdate.collaboratorId
        )
        await Promise.all([
          await this.$repository.projectRoles.updateValidationStatus(
            this.project.id,
            this.rowToUpdate.oldSupervisor.id,
            true
          ),
          await this.$repository.projectRoles.updateValidationStatus(
            this.project.id,
            this.rowToUpdate.newSupervisor.id,
            true
          ),
        ])
        showSuccessNotification(
          this,
          'El supervisor ha sido reemplazado correctamente.'
        )
      } catch (error) {
        this.handleError(
          error,
          'Ocurrió un error al confirmar el cambio de supervisor'
        )
      } finally {
        this.$store.commit('loading', false)
        this.$emit('refresh-data')
      }
    },
  },
}
